import { jsx as _jsx } from "react/jsx-runtime";
import { useBreakpoint } from '@airtel/air-design-system';
import { getPlatform } from './WithCurrentPlatformUtils';
export var withCurrentPlatform = Component => {
  var Wrapper = props => {
    var _useBreakpoint = useBreakpoint({
        returnAsObject: true
      }),
      isLargeScreen = _useBreakpoint.isLargeScreen;
    var currentPlatform = getPlatform(isLargeScreen);
    return _jsx(Component, Object.assign({}, props, {
      currentPlatform: currentPlatform
    }));
  };
  return Wrapper;
};